import * as React from 'react';

import * as styles from './AsideSection.css';

export const AsideSection = (props: React.PropsWithChildren<{}>) => {
  return <div className={styles['section']}>{props.children}</div>;
};
